export enum contactsRoute {
  persons = "persons",
  organisations = "organisations",
}

export enum distributionRoute {
  leads = "leads",
  deals = "deals",
}

export enum homeRoute {
  dashboard = "dashboard",
  tasks = "tasks",
  approvals = "approvals",
  evaluations = "evaluations",
}

export type RoutingState = {
  contacts: contactsRoute;
  distribution: distributionRoute;
  home: homeRoute;
};
